<breadcrumbs [path]="breadcrumbs"></breadcrumbs>
<h2 class="pb-2">{{localize(langSection.Breadcrumb, langText.LocationUserManagement)}}</h2>
@if (isLoading | async) {
<div>
    {{localize(langSection.Term, langText.Loading)}}
</div>
}
@if (!(isLoading | async)) {
<div>
    <div class="d-flex">
        <div class="search-bar">
            <app-location-search></app-location-search>
            <div class="display-count">{{filteredLocationsDisplayMessage}}</div>           
        </div>
        <div class="search-bar">
            <app-users-search></app-users-search>
            <div class="display-count">{{filteredUsersDisplayMessage}}</div>
        </div>
        <div class="buttons">
            <button class="ups-icon ups-icon-plus exportRequestsButton" (click)="exportLocationUsers()" [disabled]="disableExport">{{localize(langSection.LocationUserPage, langText.Export)}}</button>
            <button class="ups-icon ups-icon-plus" [routerLink]="'/location-users/add-users'">{{localize(langSection.LocationPage, langText.AddUsers)}}</button>
        </div>
    </div>
    @if (filteredUsers.length > 0 && filteredLocations.length > 0) {
<div class="sort-section">
        <location-users-location-sort class="location-sort"></location-users-location-sort>
        <location-users-user-sort class="user-sort"></location-users-user-sort>
    </div>
}
    <location-user-grid
        [locations]="displayedLocations | filterLocationsList: locationSearchTerm"
        [users]="displayedUsers | filterUsersList: usersSearchTerm"
        [filteredUsersCount]="filteredUsersCount$"
        (filteredUsers)="updateFilteredUsers($event)"
        [filteredLocationsCount]="filteredLocationsCount$"
        (filteredLocations)="updateFilteredLocations($event)"
        [unlockUsers]="unlockUsers"
        (refreshGrid)="showUsers(users)"
    ></location-user-grid>
</div>
}